import './_pageNotFound.scss';
import React from "react";

export const PageNotFound: React.FunctionComponent = () => {
	return (
		<div className="page">
			<p>Page not found.</p>
		</div>
	)
}

export default PageNotFound;
